import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth, hasRole } from "@/lib/auth";
import { PageHeader } from "@/components/common";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "@/components/ui/dialog";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { toast } from "sonner";
import { Plus } from "@phosphor-icons/react";
import { Field } from "./Employees";

export default function Designations() {
  const { user } = useAuth();
  const canManage = hasRole(user, "super_admin", "hr");
  const canDelete = hasRole(user, "super_admin");
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const empty = { name: "", description: "" };
  const [form, setForm] = useState(empty);
  const load = () => api.get("/designations").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);
  const save = async () => {
    if (!form.name) return toast.error("Name required");
    try {
      if (editing) await api.put(`/designations/${editing.id}`, form);
      else await api.post("/designations", form);
      toast.success("Saved"); setOpen(false); load();
    } catch (e) { toast.error(e?.response?.data?.detail || "Failed"); }
  };
  return (
    <div data-testid="designations-page">
      <PageHeader title="Designations" description="Job titles available across SMIPL." action={canManage && (
        <Dialog open={open} onOpenChange={setOpen}>
          <DialogTrigger asChild>
            <Button onClick={() => { setEditing(null); setForm(empty); }} className="btn-brand" data-testid="designation-new"><Plus size={16} className="mr-1.5" /> New</Button>
          </DialogTrigger>
          <DialogContent>
            <DialogHeader><DialogTitle>{editing ? "Edit" : "New"} Designation</DialogTitle></DialogHeader>
            <Field label="Name *"><Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} /></Field>
            <Field label="Description"><Textarea value={form.description || ""} onChange={(e) => setForm({ ...form, description: e.target.value })} /></Field>
            <DialogFooter><Button variant="outline" onClick={() => setOpen(false)}>Cancel</Button>
              <Button onClick={save} className="btn-brand">Save</Button></DialogFooter>
          </DialogContent>
        </Dialog>
      )} />
      <Card className="p-0 overflow-hidden">
        <Table>
          <TableHeader><TableRow><TableHead>Name</TableHead><TableHead>Description</TableHead>{canManage && <TableHead className="text-right">Actions</TableHead>}</TableRow></TableHeader>
          <TableBody>
            {items.map((d) => (
              <TableRow key={d.id}>
                <TableCell className="font-medium">{d.name}</TableCell>
                <TableCell className="text-sm text-slate-600">{d.description || "—"}</TableCell>
                {canManage && <TableCell className="text-right space-x-2">
                  <Button size="sm" variant="outline" onClick={() => { setEditing(d); setForm({ ...empty, ...d }); setOpen(true); }}>Edit</Button>
                  {canDelete && <Button size="sm" variant="outline" className="text-red-600" onClick={async () => { if (window.confirm("Delete?")) { await api.delete(`/designations/${d.id}`); toast.success("Deleted"); load(); } }}>Delete</Button>}
                </TableCell>}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Card>
    </div>
  );
}
